import { User } from 'configcat-common'
import { IFeatureFlagsClient } from './interfaces'

export class NoopFeatureFlagsClient implements IFeatureFlagsClient {
  getValueAsync(key: string, defaultValue: unknown, user?: User): Promise<unknown> {
    return Promise.resolve(defaultValue)
  }
}
